import Shipment from '../../../types/api/shipment'

export function getShipmentFloods(shipment?: Shipment | null): number | undefined {
    if (!shipment) return undefined

    const actualFloods = shipment.print_job?.actualFloods
    if (actualFloods != null) return actualFloods

    if (shipment.stampFloods != null) return shipment.stampFloods

    if (shipment.withoutCutting) {
        return shipment.virtualStamp?.floods
    }

    return shipment.stamp?.floods
}

export function isShipmentFloodsActual(shipment?: Shipment | null): boolean {
    return shipment?.print_job?.actualFloods != null
}
